import { Stack } from '@mui/material';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function ActivityIndicator() {
  return (
    <Stack
      sx={{ mt: '25vh', width: '100%' }}
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Stack>
  );
}
